import { render, staticRenderFns } from "./tree-node.vue?vue&type=template&id=03605613&scoped=true&"
import script from "./tree-node.vue?vue&type=script&lang=js&"
export * from "./tree-node.vue?vue&type=script&lang=js&"
import style0 from "./tree-node.vue?vue&type=style&index=0&id=03605613&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03605613",
  null
  
)

export default component.exports